import {gql} from "@apollo/client";

export const createAdventure = gql`
    mutation CreateAdventure($adventureName: String!, $adventureDescription: String!, $userId: Int!) {
        createAdventure(adventureName: $adventureName, adventureDescription: $adventureDescription, userId: $userId) {
            adventureId
            adventureName
            adventureDescription
        }
    }
`

export const updateAdventure = gql`
    mutation UpdateAdventure($adventureId: Int!, $adventureName: String!, $adventureDescription: String!, $user_to_adventure: [Int]!) {
        updateAdventure(adventureName: $adventureName, adventureDescription: $adventureDescription, adventureId: $adventureId, user_to_adventure: $user_to_adventure) {
            adventureDescription
            adventureId
            adventureName
            user_to_adventure {
                userToAdventureId
                User {
                    userId
                    userName
                    Character {
                        characterId
                        characterName
                    }
                }
            }
        }
    }
`

export const deleteAdventure = gql`
    mutation DeleteAdventure($adventureId: Int!) {
        deleteAdventure(adventureId: $adventureId)
    }
`